import React from 'react';
import { AiOutlineShoppingCart, AiOutlineGift, AiOutlineSetting } from 'react-icons/ai';
import { BsCurrencyBitcoin, BsCurrencyExchange, BsHouse, BsMailbox } from 'react-icons/bs';
import { SlMagnet } from 'react-icons/sl';
import { BiFirstAid, BiMapPin } from 'react-icons/bi';
import { RxDashboard } from 'react-icons/rx';
import { FaUsers, FaUsersCog } from 'react-icons/fa';
import { MdAttachMoney, MdCheckCircleOutline, MdSettingsAccessibility, MdTraffic } from 'react-icons/md';
import { HiOutlineSpeakerphone } from 'react-icons/hi';
import { GrGamepad } from 'react-icons/gr';
import { TbDeviceAnalytics } from 'react-icons/tb';
import { GrConfigure } from 'react-icons/gr';
import { IoBusinessSharp } from 'react-icons/io5';
import { HiBolt } from 'react-icons/hi2';
import { AiTwotoneBell } from 'react-icons/ai';
import { IoIosPeople } from 'react-icons/io';
import { FaMapMarkerAlt } from 'react-icons/fa';

export const links = [
  {
    title: 'Main',
    links: [
      {
        name: 'home',
        type: 'link',
        link: 'home',
        icon: <BsHouse />,
      },
      {
        name: 'users',
        type: 'link',
        link: 'users',
        icon: <FaUsers />,
      },
      {
        name: 'exchange-rates',
        type: 'link',
        link: 'exchange-rates',
        icon: <BsCurrencyExchange />
      },
      {
        name: 'currencies',
        type: 'link',
        link: 'currencies',
        icon: <BsCurrencyBitcoin />
      },
      {
        name: 'settings',
        type: 'link',
        link: 'settings',
        icon: <AiOutlineSetting />
      },
    ],
  },
  // {
  //   // title: '-- Users',
  //   links: [
  //     {
  //       name: 'Users',
  //       icon: <FaUsersCog />,
  //       subLinks: [
  //         {
  //           name: 'Mobile-Users',
  //           icon: '',
  //           type: 'link',
  //           link: "users/all"
  //         },
  //         {
  //           name: 'BO-Users',
  //           icon: '',
  //           type: 'link',
  //           link: "users/back-office"
  //         },
  //         {
  //           name: 'blocked-users',
  //           type: 'link',
  //           icon: '',
  //           link: "users/blocked"
  //         },
  //         {
  //           name: 'create',
  //           type: 'link',
  //           icon: '',
  //           link: "user/new"
  //         },
  //       ]
  //     },
  //     {
  //       name: 'alerts',
  //       type: 'parent',
  //       icon: <HiBolt size={15}/>,
  //       subLinks: [
  //         {
  //           name: 'list',
  //           icon: '',
  //           type: 'link',
  //           link: "alert/all"
  //         },
  //         {
  //           name: 'alerts-by-zone',
  //           type: 'link',
  //           icon: '',
  //           link: "alerts/zone"
  //         },
  //         {
  //           name: 'configuration-alerts',
  //           icon: '',
  //           type: 'link',
  //           link: "configuration-alerts"
  //         },
  //         {
  //           name: 'alert-types',
  //           type: 'link',
  //           icon: '',
  //           link: "alert-types"
  //         },
  //       ]
  //     },
  //     {
  //       name: 'Center of interest',
  //       type: 'link',
  //       icon: <MdCheckCircleOutline size={15}/>,
  //       link: "interest"
  //     },
  //     {
  //       name: 'Transportation modes',
  //       type: 'link',
  //       icon: <MdTraffic size={15}/>,
  //       link: "transportation-modes"
  //     },
  //   ],
  // },
  /*{
    // title: '-- Business',
    links: [
      {
        name: 'businesses',
        type: 'link',
        link: 'businesses',
        icon: <IoBusinessSharp />,
      },
     
    ],
  },
  {
    // title: '-- Business',
    links: [
      {
        name: 'notifications',
        type: 'link',
        link: 'notifications',
        icon: <AiTwotoneBell />,
      },
     
    ],
  },
  {
    // title: '-- Adverts',
    links: [
      {
        name: 'adverts',
        type: 'link',
        link: 'adverts',
        icon: <HiOutlineSpeakerphone />,
      },
     
    ],
  },
  {
    // title: '-- Adverts',
    links: [
      {
        name: 'anouncers',
        type: 'link',
        link: 'anouncers',
        icon: <IoIosPeople />,
      },
     
    ],
  },
  {
    // title: '-- Sales',
    links: [
      {
        name: 'sales',
        type: 'link',
        link: 'sales',
        icon: <MdAttachMoney size={18}/>,
      },
     
    ],
  },*/
  // {
  //   // title: '-- Analytics',
  //   links: [
  //     {
  //       name: 'analytics',
  //       type: 'link',
  //       link: 'analytics',
  //       icon: <TbDeviceAnalytics size={18}/>,
  //     },
     
  //   ],
  // },

  /*{
    links: [

      {
        name: 'Packs',
        icon: <AiOutlineGift />,
        type: 'link',
        link: "pack"
      },
     
    ],
  },*/
  // {
  //   links: [
  //     {
  //       name: 'contact',
  //       link: 'contact',
  //       type: 'link',
  //       icon: <BsMailbox />,
  //     },
     
  //   ],
  // },


  // {
  //   // title: '-- Place',
  //   links: [
  //     {
  //       name: 'Place',
  //       icon: <FaMapMarkerAlt />,
  //       subLinks: [
  //         {
  //           name: 'lieux',
  //           icon: '',
  //           type: 'link',
  //           link: "lieux"
  //         },
  //         {
  //           name: 'entreprises',
  //           type: 'link',
  //           icon: '',
  //           link: "entreprises"
  //         },
  //         {
  //           name: 'category',
  //           type: 'link',
  //           icon: '',
  //           link: "placecategory"
  //         },
  //       ]
  //     },
  //     {
  //       name: 'Traveller Mode',
  //       icon: <BiMapPin />,
  //       subLinks: [
  //         {
  //           name: 'Countries',
  //           icon: '',
  //           link: 'countries',
  //           type: "link"
  //         },
  //         {
  //           name: 'Routes',
  //           icon: '',
  //           link: 'routes',
  //           type: "link"
  //         },
  //         {
  //           name: 'Cities',
  //           icon: '',
  //           link: 'cities',
  //           type: "link"
  //         },
  //         {
  //           name: 'Trips',
  //           icon: '',
  //           link: 'trips',
  //           type: "link"
  //         },
  //         {
  //           name: 'Sign data',
  //           icon: '',
  //           link: 'sign-data',
  //           type: "link"
  //         },
  //         {
  //           name: 'Trip sign data new',
  //           icon: '',
  //           link: 'trip-sign-data-new',
  //           type: "link"
  //         },
  //         /*{
  //           name: 'Trip sign data',
  //           icon: '',
  //           link: 'trip-sign-data',
  //           type: "link"
  //         },*/
  //         {
  //           name: 'Pk data',
  //           icon: '',
  //           link: 'pk-data',
  //           type: "link"
  //         },
  //         /*{
  //           name: 'Speed limit points',
  //           icon: '',
  //           link: 'pointlv',
  //           type: "link"
  //         },*/
  //         {
  //           name: 'Maps card',
  //           icon: '',
  //           link: 'maps',
  //           type: "link"
  //         }
  //       ]
  //     }
  //   ],
  // },

  // {
  //   // title: '-- Settings',
  //   links: [
  //     {
  //       name: 'Reward settings',
  //       link: 'reward-settings',
  //       icon: <MdSettingsAccessibility />,
  //       type: 'link',
  //     },    
  //     {
  //       name: 'Settings',
  //       link: 'setting',
  //       icon: <AiOutlineSetting />,
  //       type: 'link',
  //     },
     
  //   ],
  // },
];
